import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from 'src/redesign/pages/Login/store/constants';
import {
  loginApi,
  sendLoginInit,
  sendPinCodeApi,
  verifyPinCodeApi,
} from 'src/redesign/pages/Login/store/api';
import { Attendee } from 'src/types/types';

export const initialLoginSession = createAsyncThunk(
  actionTypes.INIT_LOGIN,
  async (email: Attendee['email']) => await sendLoginInit(email),
);

export const loginAction = createAsyncThunk(
  actionTypes.LOGIN,
  async ({
    email,
    password,
    isAttendeeLogin,
  }: {
    email: Attendee['email'];
    password: string;
    isAttendeeLogin: boolean;
  }) => await loginApi(email, password, isAttendeeLogin),
);

export const sendPinCode = createAsyncThunk(
  actionTypes.SEND_PIN_CODE,
  async ({ site, email }: { site: unknown; email: Attendee['email'] }) =>
    await sendPinCodeApi(site, email),
);

export const verifyPinCode = createAsyncThunk(
  actionTypes.VERIFY_PIN_CODE,
  async ({
    email,
    codeId,
    inputCode,
    captchaToken,
    site,
    attendeeLogin,
  }: {
    site: unknown;
    email: Attendee['email'];
    captchaToken: string;
    inputCode: string;
    codeId: string;
    attendeeLogin: boolean;
  }) => await verifyPinCodeApi(site, email, captchaToken, inputCode, codeId, attendeeLogin),
);
